var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipIcongov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 22.5,
    fill: "#EAECFF",
    stroke: "#F5F6FF",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 33.1V18.8L26.2 12H18C17.2 12 16.4 12.3 15.9 12.9C15.3 13.5 15 14.2 15 15V33C15 33.8 15.3 34.6 15.9 35.1C16.5 35.7 17.2 36 18 36H30C30.8 36 31.6 35.7 32.1 35.1C32.6 34.5 33 33.9 33 33.1ZM26.2 16.6C26.2 17.2 26.4 17.8 26.9 18.2C27.3 18.6 27.9 18.9 28.5 18.9H31.5V33.1C31.5 33.5 31.3 33.9 31.1 34.2C30.9 34.5 30.4 34.6 30 34.6H18C17.6 34.6 17.2 34.4 16.9 34.2C16.6 34 16.5 33.5 16.5 33.1V15.1C16.5 14.7 16.7 14.3 16.9 14C17.2 13.7 17.6 13.6 18 13.6H26.2V16.6Z",
    fill: "#318FDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5998 31.2004V32.0004H18.5998V31.2004H22.5998ZM22.4998 27.0004L18.9998 32.1004H18.2998V31.5004L21.7998 26.5004H22.4998V27.0004ZM22.0998 26.4004V27.2004H18.2998V26.4004H22.0998ZM24.4998 26.4004V32.1004H23.3998V26.4004H24.4998ZM27.8998 30.0004H26.3998V29.2004H27.8998C28.0998 29.2004 28.2998 29.2004 28.4998 29.1004C28.6998 29.0004 28.7998 28.9004 28.7998 28.8004C28.8998 28.7004 28.8998 28.5004 28.8998 28.3004C28.8998 28.1004 28.8998 28.0004 28.7998 27.8004C28.6998 27.6004 28.5998 27.5004 28.4998 27.4004C28.3998 27.3004 28.1998 27.3004 27.8998 27.3004H26.7998V32.1004H25.6998V26.4004H27.8998C28.2998 26.4004 28.6998 26.5004 28.9998 26.6004C29.2998 26.8004 29.5998 27.0004 29.6998 27.3004C29.8998 27.6004 29.8998 27.9004 29.8998 28.2004C29.8998 28.6004 29.7998 28.9004 29.6998 29.1004C29.4998 29.4004 29.2998 29.6004 28.9998 29.7004C28.6998 29.9004 28.2998 30.0004 27.8998 30.0004Z",
    fill: "#318FDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipIcongov);
export default __webpack_public_path__ + "static/media/zip_icon.gov.415a8b1bf807e4620660043b0109067d.svg";
export { ForwardRef as ReactComponent };